// istanbul ignore file
import { ApolloLink } from '@apollo/client'
import settings from 'shared/common/settings'

const bulletLink = new ApolloLink((operation, forward) =>
  forward(operation).map((response) => {
    if (settings.appEnv === 'production') return response

    const context = operation.getContext()
    const headers = context.response?.headers
    const bulletWarning = headers?.get('X-bullet-console-text')

    if (bulletWarning) {
      /* eslint-disable no-console */
      console.group(
        `%c⚠️ OPTIMIZE YOUR QUERY: ${operation.operationName} ⚠️`,
        'color: red; font-family:monospace; font-size: 20px',
      )

      JSON.parse(bulletWarning).forEach((error: string) => {
        console.warn(error)
      })

      console.groupEnd()
      /* eslint-enable */
    }

    return response
  }),
)

export default bulletLink
